import { nextPoint, nextZIndex } from "../index.js";
//#region src/utils/table-clipboard/placement.ts
var toKey = ({ x, y }) => `${x},${y}`;
var compareId = (a, b) => a < b ? -1 : a > b ? 1 : 0;
var kindRank = ({ kind }) => kind === "memo" ? 1 : 0;
var toZIndex = (entity) => entity.ui.zIndex ?? 0;
function resolvePlacement({ entities, offset, escapeCollision, settings, tables, memos, findSource }) {
	const placement = /* @__PURE__ */ new Map();
	if (entities.length === 0) return placement;
	const taken = new Set([...tables, ...memos].map(({ ui }) => toKey(ui)));
	const points = /* @__PURE__ */ new Map();
	const absent = [];
	for (const entity of entities) {
		const source = findSource(entity.sourceId);
		if (source) points.set(entity.sourceId, {
			x: source.ui.x + offset.x,
			y: source.ui.y + offset.y
		});
		else absent.push(entity);
	}
	if (absent.length !== 0) {
		const anchor = nextPoint(settings, tables, memos);
		const originRef = absent.reduce((acc, entity) => entity.ui.x < acc.ui.x || entity.ui.x === acc.ui.x && entity.ui.y < acc.ui.y ? entity : acc);
		for (const entity of absent) points.set(entity.sourceId, {
			x: anchor.x + (entity.ui.x - originRef.ui.x),
			y: anchor.y + (entity.ui.y - originRef.ui.y)
		});
	}
	if (escapeCollision) {
		const ordered = [...entities].sort((a, b) => compareId(a.sourceId, b.sourceId));
		for (const { sourceId } of ordered) {
			const point = points.get(sourceId);
			if (!point) continue;
			while (taken.has(toKey(point))) {
				point.x += 50;
				point.y += 50;
			}
			taken.add(toKey(point));
		}
	}
	const baseZIndex = nextZIndex(tables, memos);
	[...entities].sort((a, b) => toZIndex(a) - toZIndex(b) || kindRank(a) - kindRank(b) || compareId(a.sourceId, b.sourceId)).forEach(({ sourceId }, index) => {
		const point = points.get(sourceId);
		if (!point) return;
		placement.set(sourceId, {
			x: point.x,
			y: point.y,
			zIndex: baseZIndex + index
		});
	});
	return placement;
}
//#endregion
export { resolvePlacement };
